// extracted by mini-css-extract-plugin
export default {"wrapper":"vimeo__wrapper__B3yqT","full":"vimeo__full__bYgYW","maintainAspectRatio":"vimeo__maintainAspectRatio__huqUO"};